export default "__VITE_ASSET__63f3bdb4__"